module.exports = __webpack_public_path__ + "static/service4-c02410cd90a59236c8c29a886bdd32d6.jpg";